<template>
    <rkm-overlay>
        <rkm-layout-body title="Formulário RAAS">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/formulario-raas/List'

export default {
    components: { List }
}
</script>